"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLocalVideoTrack = void 0;
function isLocalVideoTrack(track) {
    // This doesn't seem like the best way to determine this. I'd rather have an explicit isLocal() method or something,
    // but I'm not going to mess with it right now - JG
    return track.restart !== undefined;
}
exports.isLocalVideoTrack = isLocalVideoTrack;
//# sourceMappingURL=guards.js.map